'use strict';

var Moment = require("moment");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Item$PvpcontrollerWeb = require("../Item.js");
var Boolean$PvpcontrollerWeb = require("../Boolean.js");

var armorIcon = "/armor-icon.png";

var minute = 1000.0 * 60.0;

var hour = minute * 60.0;

var day = hour * 24.0;

var week = day * 7.0;

function toString(timestamp, dayOnlyOpt, param) {
  var dayOnly = dayOnlyOpt !== undefined ? dayOnlyOpt : false;
  var date = new Date(timestamp);
  var year = date.getFullYear();
  var now = new Date(Date.now());
  var thisYear = now.getFullYear();
  var datestamp = new Date(timestamp).setHours(23.0, 0.0, 0.0, 0.0);
  var datestampDate = new Date(datestamp).getDate();
  var todayDate = now.getDate();
  var dateDifference = todayDate - datestampDate;
  var sameMonth = date.getMonth() === now.getMonth();
  if (thisYear > year) {
    return Moment(date).format("MMMM Do, YYYY");
  } else if (sameMonth && dateDifference < 7.0) {
    if (datestampDate === todayDate) {
      if (dayOnly) {
        return "Today";
      } else {
        return Moment(date).fromNow(undefined);
      }
    } else if (dateDifference === 1.0) {
      return "Yesterday";
    } else {
      return String(dateDifference) + " day" + (
              dateDifference < 2.0 ? "" : "s"
            ) + " ago";
    }
  } else {
    return Moment(date).format("MMMM Do");
  }
}

var Timestamp = {
  second: 1000.0,
  minute: minute,
  hour: hour,
  day: day,
  week: week,
  toString: toString
};

function isNerf(param) {
  var change = param.info;
  switch (change.TAG | 0) {
    case /* Weapon */0 :
        var change$1 = change._1;
        switch (change$1.TAG | 0) {
          case /* Damage */0 :
          case /* Velocity */1 :
              break;
          case /* MaxDamage */2 :
              var param$1 = change$1._0;
              var $$new = param$1.new;
              var old = param$1.old;
              if (old !== undefined) {
                if ($$new !== undefined) {
                  return Caml_obj.caml_lessthan(Caml_option.valFromOption($$new), Caml_option.valFromOption(old));
                } else {
                  return false;
                }
              } else {
                return $$new !== undefined;
              }
          case /* MinDamage */3 :
              var param$2 = change$1._0;
              var $$new$1 = param$2.new;
              var old$1 = param$2.old;
              if (old$1 !== undefined) {
                if ($$new$1 !== undefined) {
                  return Caml_obj.caml_lessthan(Caml_option.valFromOption($$new$1), Caml_option.valFromOption(old$1));
                } else {
                  return true;
                }
              } else {
                return false;
              }
          case /* Banned */4 :
              return change$1._0.new;
          
        }
        var match = change$1._0;
        return match.new < match.old;
    case /* Projectile */1 :
        var change$2 = change._1;
        switch (change$2.TAG | 0) {
          case /* DamageRatio */0 :
          case /* VelocityRatio */1 :
              break;
          case /* Banned */2 :
              return change$2._0.new;
          
        }
        var match$1 = change$2._0;
        return match$1.new < match$1.old;
    case /* ArmorPiece */2 :
        var change$3 = change._1;
        return change$3._0.new < change$3._0.old;
    case /* Settings */3 :
        var change$4 = change._0;
        switch (change$4.TAG | 0) {
          case /* BannedEquipment */0 :
          case /* BanTeleportItems */2 :
          case /* BanPrefixedArmor */3 :
          case /* PreventImpossibleEquipment */6 :
              return change$4._0.new;
          case /* NeverRain */14 :
          case /* AllowHookOfDissonance */15 :
          case /* CorrectPositionDesync */16 :
              return !change$4._0.new;
          case /* DamageDisableSeconds */1 :
          case /* PotionHealCooldown */5 :
          case /* DamageVariation */19 :
              break;
          case /* ForceMaxHealth */13 :
          case /* Time */20 :
              return false;
          default:
            var match$2 = change$4._0;
            return match$2.new < match$2.old;
        }
        var match$3 = change$4._0;
        return match$3.new > match$3.old;
    
  }
}

function changeObjectTypeName(param) {
  switch (param.info.TAG | 0) {
    case /* Weapon */0 :
        return "Weapon";
    case /* Projectile */1 :
        return "Projectile";
    case /* ArmorPiece */2 :
        return "Armor Piece";
    case /* Settings */3 :
        return "Setting";
    
  }
}

function changeValueTypeName(param) {
  var change = param.info;
  switch (change.TAG | 0) {
    case /* Weapon */0 :
        switch (change._1.TAG | 0) {
          case /* Damage */0 :
              return "Damage";
          case /* Velocity */1 :
              return "Velocity";
          case /* MaxDamage */2 :
              return "Max Damage";
          case /* MinDamage */3 :
              return "Min Damage";
          case /* Banned */4 :
              return "Banned";
          
        }
    case /* Projectile */1 :
        switch (change._1.TAG | 0) {
          case /* DamageRatio */0 :
              return "Damage";
          case /* VelocityRatio */1 :
              return "Velocity";
          case /* Banned */2 :
              return "Banned";
          
        }
    case /* ArmorPiece */2 :
        switch (change._1.TAG | 0) {
          case /* Defense */0 :
              return "Defense";
          case /* MeleeDamagePercentage */1 :
              return "Melee Bonus";
          case /* MagicDamagePercentage */2 :
              return "Magic Bonus";
          case /* RangedDamagePercentage */3 :
              return "Ranged Bonus";
          case /* MinionDamagePercentage */4 :
              return "Minion Bonus";
          
        }
    case /* Settings */3 :
        switch (change._0.TAG | 0) {
          case /* BannedEquipment */0 :
              return "Banned Equipment";
          case /* DamageDisableSeconds */1 :
              return "Damage Disable Seconds";
          case /* BanTeleportItems */2 :
              return "Ban Teleport Items";
          case /* BanPrefixedArmor */3 :
              return "Ban Prefixed Armor";
          case /* PotionHealAmount */4 :
              return "Potion Heal Amount";
          case /* PotionHealCooldown */5 :
              return "Potion Heal Cooldown";
          case /* PreventImpossibleEquipment */6 :
              return "Prevent Impossible Equipment";
          case /* BeetleArmorStage1 */7 :
              return "Beetle Armor Stage 1";
          case /* BeetleArmorStage2 */8 :
              return "Beetle Armor Stage 2";
          case /* BeetleArmorStage3 */9 :
              return "Beetle Armor Stage 3";
          case /* SolarArmorStage1 */10 :
              return "Solar Armor Stage 1";
          case /* SolarArmorStage2 */11 :
              return "Solar Armor Stage 2";
          case /* SolarArmorStage3 */12 :
              return "Solar Armor Stage 3";
          case /* ForceMaxHealth */13 :
              return "Force Max Health";
          case /* NeverRain */14 :
              return "Never Rain";
          case /* AllowHookOfDissonance */15 :
              return "Allow Hook Of Dissonance";
          case /* CorrectPositionDesync */16 :
              return "Correct Position Desync";
          case /* CorrectionMinDistance */17 :
              return "Correction Min Distance";
          case /* DefenseMultiplier */18 :
              return "Defense Multiplier";
          case /* DamageVariation */19 :
              return "Damage Variation";
          case /* Time */20 :
              return "Time";
          
        }
    
  }
}

function asPercentage(num) {
  var number = (num * 100.0 | 0).toString();
  return number + "%";
}

function asIntPercentage(num) {
  var number = num.toString();
  return number + "%";
}

function toTimeString(time) {
  var hours = time / 100 | 0;
  var minutes = time - Math.imul(hours, 100) | 0;
  var hoursStr = hours.toString();
  var hoursStr$1 = hoursStr.length === 1 ? "0" + hoursStr : hoursStr;
  var minutesStr = minutes.toString();
  var minutesStr$1 = minutesStr.length === 1 ? "0" + minutesStr : minutesStr;
  return hoursStr$1 + ":" + minutesStr$1;
}

function oldAsString(param) {
  var change = param.info;
  switch (change.TAG | 0) {
    case /* Weapon */0 :
        var change$1 = change._1;
        switch (change$1.TAG | 0) {
          case /* Damage */0 :
          case /* Velocity */1 :
              return change$1._0.old.toString();
          case /* MaxDamage */2 :
              var old = change$1._0.old;
              if (old !== undefined) {
                return old.toString();
              } else {
                return "None";
              }
          case /* MinDamage */3 :
              var old$1 = change$1._0.old;
              if (old$1 !== undefined) {
                return old$1.toString();
              } else {
                return "None";
              }
          case /* Banned */4 :
              return Boolean$PvpcontrollerWeb.toHumanString(change$1._0.old);
          
        }
    case /* Projectile */1 :
        var change$2 = change._1;
        switch (change$2.TAG | 0) {
          case /* DamageRatio */0 :
          case /* VelocityRatio */1 :
              return asPercentage(change$2._0.old);
          case /* Banned */2 :
              return Boolean$PvpcontrollerWeb.toHumanString(change$2._0.old);
          
        }
    case /* ArmorPiece */2 :
        var change$3 = change._1;
        if (change$3.TAG === /* Defense */0) {
          return change$3._0.old.toString();
        } else {
          return asIntPercentage(change$3._0.old);
        }
    case /* Settings */3 :
        var change$4 = change._0;
        switch (change$4.TAG | 0) {
          case /* DamageDisableSeconds */1 :
          case /* PotionHealAmount */4 :
          case /* PotionHealCooldown */5 :
          case /* CorrectionMinDistance */17 :
              return change$4._0.old.toString();
          case /* BeetleArmorStage1 */7 :
          case /* BeetleArmorStage2 */8 :
          case /* BeetleArmorStage3 */9 :
          case /* SolarArmorStage1 */10 :
          case /* SolarArmorStage2 */11 :
          case /* SolarArmorStage3 */12 :
          case /* DefenseMultiplier */18 :
          case /* DamageVariation */19 :
              return change$4._0.old.toString() + "%";
          case /* Time */20 :
              return toTimeString(change$4._0.old);
          default:
            return Boolean$PvpcontrollerWeb.toHumanString(change$4._0.old);
        }
    
  }
}

function newAsString(param) {
  var change = param.info;
  switch (change.TAG | 0) {
    case /* Weapon */0 :
        var change$1 = change._1;
        switch (change$1.TAG | 0) {
          case /* Damage */0 :
          case /* Velocity */1 :
              return change$1._0.new.toString();
          case /* MaxDamage */2 :
              var $$new = change$1._0.new;
              if ($$new !== undefined) {
                return $$new.toString();
              } else {
                return "None";
              }
          case /* MinDamage */3 :
              var $$new$1 = change$1._0.new;
              if ($$new$1 !== undefined) {
                return $$new$1.toString();
              } else {
                return "None";
              }
          case /* Banned */4 :
              return Boolean$PvpcontrollerWeb.toHumanString(change$1._0.new);
          
        }
    case /* Projectile */1 :
        var change$2 = change._1;
        switch (change$2.TAG | 0) {
          case /* DamageRatio */0 :
          case /* VelocityRatio */1 :
              return asPercentage(change$2._0.new);
          case /* Banned */2 :
              return Boolean$PvpcontrollerWeb.toHumanString(change$2._0.new);
          
        }
    case /* ArmorPiece */2 :
        var change$3 = change._1;
        if (change$3.TAG === /* Defense */0) {
          return change$3._0.new.toString();
        } else {
          return asIntPercentage(change$3._0.new);
        }
    case /* Settings */3 :
        var change$4 = change._0;
        switch (change$4.TAG | 0) {
          case /* DamageDisableSeconds */1 :
          case /* PotionHealAmount */4 :
          case /* PotionHealCooldown */5 :
          case /* CorrectionMinDistance */17 :
              return change$4._0.new.toString();
          case /* BeetleArmorStage1 */7 :
          case /* BeetleArmorStage2 */8 :
          case /* BeetleArmorStage3 */9 :
          case /* SolarArmorStage1 */10 :
          case /* SolarArmorStage2 */11 :
          case /* SolarArmorStage3 */12 :
          case /* DefenseMultiplier */18 :
          case /* DamageVariation */19 :
              return change$4._0.new.toString() + "%";
          case /* Time */20 :
              return toTimeString(change$4._0.new);
          default:
            return Boolean$PvpcontrollerWeb.toHumanString(change$4._0.new);
        }
    
  }
}

function isSimpleValueChange(param) {
  var change = param.info;
  if (change.TAG === /* Settings */3 && change._0.TAG === /* BannedEquipment */0) {
    return false;
  } else {
    return true;
  }
}

function getComplexValueChange(param) {
  var change = param.info;
  var netId = param.netId;
  switch (change.TAG | 0) {
    case /* Weapon */0 :
    case /* Projectile */1 :
    case /* ArmorPiece */2 :
        return "";
    case /* Settings */3 :
        var change$1 = change._0;
        if (change$1.TAG === /* BannedEquipment */0) {
          if (change$1._0.new) {
            return "Banned " + Caml_array.get(Item$PvpcontrollerWeb.items, netId);
          } else {
            return "Unbanned " + Caml_array.get(Item$PvpcontrollerWeb.items, netId);
          }
        } else {
          return "";
        }
    
  }
}

var imageUrl = "https://pvpmanager.dark-gaming.com/img";

function toImageName(name) {
  return name.replace(/ /g, "_");
}

function image(param) {
  var change = param.info;
  switch (change.TAG | 0) {
    case /* Projectile */1 :
        return "";
    case /* Weapon */0 :
    case /* ArmorPiece */2 :
        return imageUrl + "/" + toImageName(change._0) + ".png";
    case /* Settings */3 :
        if (change._0.TAG === /* BannedEquipment */0) {
          return imageUrl + "/" + toImageName(Caml_array.get(Item$PvpcontrollerWeb.items, param.netId)) + ".png";
        } else {
          return "";
        }
    
  }
}

function subjectName(param) {
  var change = param.info;
  switch (change.TAG | 0) {
    case /* Projectile */1 :
        return change._0 + " (" + param.netId.toString() + ")";
    case /* Weapon */0 :
    case /* ArmorPiece */2 :
        return change._0;
    case /* Settings */3 :
        return "Settings";
    
  }
}

function sourceLink(param) {
  var netId = param.netId;
  switch (param.info.TAG | 0) {
    case /* Weapon */0 :
        return "/weapon/" + netId.toString();
    case /* Projectile */1 :
        return "/projectile/" + netId.toString();
    case /* ArmorPiece */2 :
        return "/armorPiece/" + netId.toString();
    case /* Settings */3 :
        return "/settings";
    
  }
}

function changeTypeIcon(param) {
  var change = param.info;
  switch (change.TAG | 0) {
    case /* Projectile */1 :
        return "/arrow-icon.png";
    case /* Weapon */0 :
    case /* ArmorPiece */2 :
        return "";
    case /* Settings */3 :
        switch (change._0.TAG | 0) {
          case /* BannedEquipment */0 :
          case /* BanPrefixedArmor */3 :
          case /* BeetleArmorStage1 */7 :
          case /* BeetleArmorStage2 */8 :
          case /* BeetleArmorStage3 */9 :
          case /* SolarArmorStage1 */10 :
          case /* SolarArmorStage2 */11 :
          case /* SolarArmorStage3 */12 :
              return armorIcon;
          default:
            return "/gear-icon.png";
        }
    
  }
}

exports.Timestamp = Timestamp;
exports.isNerf = isNerf;
exports.changeObjectTypeName = changeObjectTypeName;
exports.changeValueTypeName = changeValueTypeName;
exports.toTimeString = toTimeString;
exports.oldAsString = oldAsString;
exports.newAsString = newAsString;
exports.isSimpleValueChange = isSimpleValueChange;
exports.getComplexValueChange = getComplexValueChange;
exports.imageUrl = imageUrl;
exports.toImageName = toImageName;
exports.image = image;
exports.subjectName = subjectName;
exports.sourceLink = sourceLink;
exports.changeTypeIcon = changeTypeIcon;
/* moment Not a pure module */
